const MOBILE = 480;
const MEDIUM = 1080;

export const MediaQueries = {
  onlyMobile: `@media (max-width: ${MOBILE}px)`,
  notMobile: `@media (min-width: ${MOBILE + 1}px)`,
  medium: `@media (max-width: ${MEDIUM}px)`,
  desktop: `@media (min-width: ${700}px)`,
  notDesktop: `@media (max-width: ${700 + 1}px)`
};

export const headerHeight = 56;
export const paddingLarge = '15vh';
export const paddingMedium = '40px';
export const paddingSmall = '20px';
